// Using simple HTML icons instead of react-icons for TypeScript compatibility
import { ResultsContent, PromptContent } from "../../types/roiCalculator";

interface InitialResultsProps {
  results: ResultsContent;
  prompt: PromptContent;
  onSubmit: (e: React.FormEvent) => void;
  submitButtonText: string;
}

const InitialResults = ({
  results,
  prompt,
  submitButtonText,
}: InitialResultsProps) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-lg p-8 shadow-lg flex-1 flex flex-col">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-slate-800 mb-4 font-productSans">
          Find Your Potential ROI
        </h3>
        <p className="text-slate-600 mb-8">
          Estimate your clinic's potential revenue gains, cost savings, and time saved with <span className="font-bold">Notation's</span> AI-powered documentation.
        </p>
      </div>

      {/* Top 3 Cards - No titles */}
      <div className="flex-1 flex flex-col justify-center">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="p-4 bg-slate-50 rounded-lg text-center">
            <div className="flex justify-center mb-3">
              <svg className="w-8 h-8 text-[#619ed3]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="text-2xl font-bold text-[#619ed3]">
              $36k - $50k
            </div>
            <div className="text-sm text-slate-500">{results.moneySavedText}</div>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg text-center">
            <div className="flex justify-center mb-3">
              <svg className="w-8 h-8 text-[#619ed3]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="text-2xl font-bold text-[#619ed3]">240 - 360 hrs</div>
            <div className="text-sm text-slate-500">{results.hoursSavedText}</div>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg text-center">
            <div className="flex justify-center mb-3">
              <svg className="w-8 h-8 text-[#619ed3]" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="text-2xl font-bold text-[#619ed3]">2x - 8x</div>
            <div className="text-sm text-slate-500">{results.roiText}</div>
          </div>
      </div>
      </div>

      <div className="mt-auto bg-slate-100 p-6 rounded-lg text-center">
        <h4 className="font-bold text-lg text-slate-800 mb-2 font-productSans">
          {prompt.title}
        </h4>
        <p className="text-slate-600 text-sm mb-4">{prompt.desc}</p>
        <a
          href="https://bookings.cloud.microsoft/book/NotationAI@fownd.org/?ismsaljsauthenabled"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full inline-block bg-[#1e3d3b] text-white font-semibold px-6 py-3 rounded-md hover:bg-[#2a5a56] transition-colors"
        >
          {submitButtonText}
        </a>
      </div>
    </div>
  );
};

export default InitialResults;
